import React from "react";
import classes from "./About.module.css";
import Space from "../../UI/Space/Space";

import AnimatedCard from "../../UI/AnimatedCard/AnimatedCard"; //fade in animation
import logoHD from "../../../images/logoHD.png";
import Person from "../../../images/Person.png";
import Group from "../../../images/Group.png";

//This component was written as a replacement for OurWork.js with different more concise design
const About = (props) => {
  return (
    // container of the whole component
    <div className={classes.container}>
      {/* <Space height={50}/> */}

      {/* The column with the Text About LWAH */}
      <div className={classes.column}>
        <h5>
          <span className={classes.yellow}> LWAH</span> is non-governmental not
          for profit organization founded in 1984, by Mrs. Randa Assi Berri and
          has special consultative status with the UN economic and social
          council since the year 2000.
          <br />
          <div className={classes.imgContainer}>
            <img src={logoHD} />
          </div>
          <br />
          Its mission is to improve the quality of life for people with special
          needs and enhance their dignity, independence and productivity.
          <br />
          <div className={classes.imgContainer}>
            <img src={Person} />
          </div>
          <br />
          <span className={classes.yellow}>LWAH</span> provides full
          rehabilitation services through its three centers in Beirut, Baalbek,
          and Sarafand. Its main center is the Nabih Berri Rehabilitation
          Compound (NBRC), built over an area of 23,000 m² in South Lebanon. It
          offers comprehensive medical and rehabilitation services through its
          different units, ranging from diagnosis and treatment to physical
          therapy, psychosocial, educational, occupational, vocational, and
          recreational rehabilitation.{" "}
          <span className={classes.yellow}>LWAH</span> also partners with
          Phoenicia University (PU), seeking consultation from PU faculty
          members, where necessary, in relation to rehabilitation services,
          events, campaigns, and other related activities.{" "}
          <span className={classes.yellow}>LWAH</span> serves more than 340
          patients per day and has over 39,000 registered patients.
          <br />
          <div className={classes.imgContainer}>
            <img src={Group} />
          </div>
          <br />
          It has come far in the last few years, and with the commitment of its
          professional and dedicated staff,{" "}
          <span className={classes.yellow}>LWAH</span> is proud to have acquired
          ISO certification 9001:2008 after effectively implementing the set of
          requirements insuring quality management.
          
        </h5>
      </div>
      {/* <Space height={50}/> */}
    </div>
  );
};
export default About;
